<template>
	<AppContentLayout>
		<div class="display-flex flex-stretch-to-scroll height-100">
			<div class="page-left-side">
				<LoaderWrapper :isLoading="loadingProcesses">
					<div v-if="processes?.length">
						<perfect-scrollbar>
							<v-list>
								<v-list-item-group active-class="border">
									<v-list-item v-for="proc in processes" :key="proc.processId" @click="setSelectedItem(proc)">
										<v-list-item-content>
											<v-list-item-title>{{ proc.title }}</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</v-list-item-group>
							</v-list>
						</perfect-scrollbar>
					</div>

					<div v-else>No processes found</div>
				</LoaderWrapper>
			</div>
			<div class="vertical-divider" />
			<router-view></router-view>
		</div>
	</AppContentLayout>
</template>

<script>
import router from '@/router';
import AppContentLayout from '../AppLayout/AppContentLayout';
import { mapGetters, mapActions } from 'vuex';
import { loadingProcesses, processes, selectedProcess } from '@/store/modules/processReports/getters';
import { loadProcesses, loadProcess } from '@/store/modules/processReports/actions';

export default {
	name: 'ProcessReports',
	components: {
		AppContentLayout,
	},
	computed: {
		...mapGetters([loadingProcesses.fullPath, processes.fullPath, selectedProcess.fullPath]),
		loadingProcesses() {
			return this[loadingProcesses.fullPath];
		},
		processes() {
			return this[processes.fullPath];
		},
		selectedProcess() {
			return this[selectedProcess.fullPath];
		},
	},
	methods: {
		...mapActions([loadProcesses.fullPath, loadProcess.fullPath]),
		async setSelectedItem({ processId }) {
			if (processId != this.selectedProcess?.processId) {
				router.push({ name: 'ProcessReportsInfo', params: { processId } });
				await this[loadProcess.fullPath](processId);
			}
		},
	},
	created() {
		this[loadProcesses.fullPath]();
	},
};
</script>
